import { MainComponent } from './pages/main/main.component';
//import { UnauthenticatedGuard } from './guards/unauthenticated/unauthenticated.guard';
//import { AuthenticatedGuard } from './guards/authenticated/authenticated.guard';
import { LoginComponent } from './pages/login/login.component';
import { DashComponent } from './parts/dash/dash.component';
import { ForgotpasswordComponent } from './component/forgotpassword/forgotpassword.component';

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import{AuthGuard} from './auth.guard';
import { PlanmasterComponent } from './component/planmaster/planmaster.component';
import { TestmasterComponent } from './component/testmaster/testmaster.component';
import { AddedittestComponent } from './component/addedittest/addedittest.component'
import { PlanmasteraddeditComponent } from './component/planmasteraddedit/planmasteraddedit.component';
import { SpecialitymasterComponent } from './component/specialitymaster/specialitymaster.component';
import { AddeditspecialityComponent } from './component/addeditspeciality/addeditspeciality.component';
import { AddeditorganisationComponent } from './component/addeditorganisation/addeditorganisation.component'
import { OrganisationmasterComponent } from './component/organisationmaster/organisationmaster.component'
import { AddeditNotificationMasterComponent } from './component/addedit-notification-master/addedit-notification-master.component'

import { NotificationMasterComponent } from './component/notificationmaster/notification-master.component'
import { OrganisationTypeMasterComponent } from './component/organisation-type-master/organisation-type-master.component';
import { AddeditorganisationTypeComponent } from './component/addeditorganisation-type/addeditorganisation-type.component';
import { QueueTemplateComponent } from './component/queue-template/queue-template.component';
import { AddeditQueueTemplateComponent } from './component/addedit-queue-template/addedit-queue-template.component';
import { LanguageMasterComponent } from './component/language/language-master/language-master.component';
import { AddeditLanguageComponent } from './component/language/addedit-language/addedit-language.component';
import { ChangepasswordComponent } from './component/changepassword/changePassword.component';





const routes: Routes = [

  {
    path: 'forgotpassword',
    component: ForgotpasswordComponent,
    
  },



{
path: 'login',
component: LoginComponent,
},
{
  path: '',
  component: DashComponent,
  canActivate: [AuthGuard],
  children: [
    
{ path: '', 
    component: MainComponent, 
    canActivate: [AuthGuard] 
    },
    {
  path: 'organisation',
  component: OrganisationmasterComponent,
  canActivate: [AuthGuard],
 },
 {
  path: 'plan',
  component: PlanmasterComponent,
  canActivate: [AuthGuard],
 },
 {
   path: 'plan/planaddedit',
   component: PlanmasteraddeditComponent,
   canActivate: [AuthGuard],
  },
  {
    path: 'plan/planaddedit/:planid',
    component: PlanmasteraddeditComponent,
    canActivate: [AuthGuard],
   },
   {
    path: 'test',
    component: TestmasterComponent,
    canActivate: [AuthGuard],
   },
   {
    path: 'test/testaddedit',
    component: AddedittestComponent,
    canActivate: [AuthGuard],
   },
   {
    path: 'test/testaddedit/:testid',
    component: AddedittestComponent,
    canActivate: [AuthGuard],
   },
   {
    path: 'speciality',
    component: SpecialitymasterComponent,
    canActivate: [AuthGuard],
   },
   {
    path: 'speciality/specialityaddedit',
    component: AddeditspecialityComponent,
    canActivate: [AuthGuard],
   },
   {
    path: 'speciality/specialityaddedit/:speciality_id',
    component: AddeditspecialityComponent,
    canActivate: [AuthGuard],
   },
   {
     path: 'organisation-type',
     component: OrganisationTypeMasterComponent,
     canActivate: [AuthGuard],
   },
  {
    path: 'organisation-type/addeditorganisation-type',
    component: AddeditorganisationTypeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'organisation-type/addeditorganisation-type/:orgtype_id',
    component: AddeditorganisationTypeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'queue-template',
    component: QueueTemplateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'queue-template/addeditqueuetemplate/:queue_template_id',
    component: AddeditQueueTemplateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'language-master',
    component: LanguageMasterComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'language-master/addedit-language',
    component: AddeditLanguageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'language-master/addedit-language/:language_id',
    component: AddeditLanguageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'queue-template/addeditqueuetemplate',
    component: AddeditQueueTemplateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'organisation/addeditorganisation',
    component: AddeditorganisationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'organisation/addeditorganisation/:orgid',
    component: AddeditorganisationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'notification',
    component: NotificationMasterComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'notification/addeditnotification',
    component: AddeditNotificationMasterComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'notification/addeditnotification/:nid',
    component: AddeditNotificationMasterComponent,
    canActivate: [AuthGuard],
  },







  {
    path: 'changepassword',
    component: ChangepasswordComponent,
    canActivate: [AuthGuard],
   },
  




  { path: '**', redirectTo: '' }
]
},
]
/*
const routes: Routes = [

  
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [UnauthenticatedGuard]
  },
  {
    path: 'forgot',
    component: ForgotPasswordComponent,
    canActivate: [UnauthenticatedGuard]
  },
  {
    path: '',
    component: DashComponent,
    canActivate: [AuthenticatedGuard],
    children: [
      { component: MainComponent, path: 'main' },
      { component: MainComponent, path: 'main1' },
      { component: MainComponent, path: 'main2' },
      { component: MainComponent, path: 'main3' },
      { component: MainComponent, path: 'main4' },
      { component: MainComponent, path: 'main5' },
    
    
    
    ]
  }


,
{
  path: '',
  redirectTo: '/',
  pathMatch: 'full'
},
{
  path: 'plan',
  component: PlanmasterComponent
 },
 {
   path: 'plan/planaddedit',
   component: PlanmasteraddeditComponent,
   canActivate: [AuthenticatedGuard],
  },
  {
    path: 'plan/planaddedit/:planid',
    component: PlanmasteraddeditComponent,
    canActivate: [AuthenticatedGuard],
   },
   {
    path: 'test',
    component: TestmasterComponent,
    canActivate: [AuthenticatedGuard],
   },
   {
    path: 'test/testaddedit',
    component: AddedittestComponent,
    canActivate: [AuthenticatedGuard],
   },
   {
    path: 'test/testaddedit/:testid',
    component: AddedittestComponent,
    canActivate: [AuthenticatedGuard],
   },
   {
    path: 'speciality',
    component: SpecialitymasterComponent,
    canActivate: [AuthenticatedGuard],
   },
   {
    path: 'speciality/specialityaddedit',
    component: AddeditspecialityComponent,
    canActivate: [AuthenticatedGuard],
   },
   {
    path: 'speciality/specialityaddedit/:speciality_id',
    component: AddeditspecialityComponent,
    canActivate: [AuthenticatedGuard],
   },
  {
    path: 'organisation/addeditorganisation',
    component: AddeditorganisationComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'organisation',
    component: OrganisationmasterComponent,
    canActivate: [AuthenticatedGuard],
  },

];


*/


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts